var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8124 11.1575L12.282 10.6271L11.2214 11.6878L11.7517 12.2181L12.8124 11.1575ZM15.1297 15.5961C15.4226 15.889 15.8974 15.889 16.1903 15.5961C16.4832 15.3032 16.4832 14.8283 16.1903 14.5354L15.1297 15.5961ZM13.3545 7.28802C13.3545 10.3102 10.9045 12.7603 7.88223 12.7603L7.88221 14.2603C11.7329 14.2603 14.8545 11.1387 14.8545 7.28801L13.3545 7.28802ZM7.88223 12.7603C4.86 12.7603 2.41004 10.3104 2.41007 7.28813L0.910075 7.28815C0.910025 11.1388 4.03155 14.2603 7.88221 14.2603L7.88223 12.7603ZM2.41007 7.28813C2.41011 4.26591 4.86014 1.81589 7.88237 1.81585L7.88239 0.315855C4.03174 0.315894 0.910125 3.4375 0.910075 7.28815L2.41007 7.28813ZM7.88237 1.81585C10.9046 1.81582 13.3546 4.2658 13.3545 7.28802L14.8545 7.28801C14.8546 3.43735 11.733 0.315815 7.88239 0.315855L7.88237 1.81585ZM11.7517 12.2181L15.1297 15.5961L16.1903 14.5354L12.8124 11.1575L11.7517 12.2181Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.01c3009bb33baa68f0ea9daad08633c1.svg";
export { ForwardRef as ReactComponent };